import React from "react";
import {
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useGetDeviceTypesQuery } from "app/store/dashboard/account_analytic/api/accountAnalyticApi";
import { CloseOutlined } from "@mui/icons-material";

const DeviceTypeFilter = ({
  displayAll = true,
  label = undefined,
  onChange,
  value,
  disabled = false,
  multiple = false,
  ...props
}) => {
  const { data } = useGetDeviceTypesQuery({ includeHF: false });
  const deviceTypes = data?.map((device) => device?.shortName);
  const multipleSelectedValue = Array.isArray(value) ? value : [value];
  const { required, error, helperText } = props;

  return (
    <>
      <FormControl fullWidth required={required} error={error}>
        <InputLabel id="device-type-select-label">
          {label || "Device Type"}
        </InputLabel>

        <Select
          multiple={multiple}
          labelId="device-type-select-label"
          id="device-type-select-helper"
          value={multiple ? multipleSelectedValue : value || ""}
          label={label || "Device Type"}
          onChange={onChange}
          disabled={disabled || deviceTypes?.length <= 1}
          required={required}
          slotProps={{
            textfield: {
              helperText,
            },
          }}
          sx={
            multiple && multipleSelectedValue.length > 0
              ? {
                  "& .MuiOutlinedInput-input": {
                    padding: "12px 12px !important",
                  },
                }
              : {}
          }
          renderValue={(selected) =>
            multiple ? (
              <div className="d-flex flex-wrap g-1">
                {selected.map((value) => (
                  <Chip
                    key={value}
                    label={value}
                    size="medium"
                    variant="outlined"
                    deleteIcon={<CloseOutlined />}
                    onMouseDown={(e) => e.stopPropagation()}
                    onPointerDown={(e) => e.stopPropagation()}
                    onDelete={(e) => {
                      e.stopPropagation();
                      const newValue = multipleSelectedValue.filter(
                        (v) => v !== value
                      );
                      onChange({ target: { value: newValue } });
                    }}
                    sx={{ gap: 0.5 }}
                  />
                ))}
              </div>
            ) : (
              selected
            )
          }
        >
          {displayAll && deviceTypes?.length > 1 && (
            <MenuItem value="all">All</MenuItem>
          )}
          {deviceTypes?.map((deviceType, index) => {
            const isSelected = multiple
              ? multipleSelectedValue.includes(deviceType)
              : value === deviceType;

            return (
              <MenuItem key={index} value={deviceType}>
                {multiple && <Checkbox checked={isSelected} />}

                {deviceType}
              </MenuItem>
            );
          })}
        </Select>

        {error && (
          <FormHelperText error>
            {helperText || "Device Type is required."}
          </FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default DeviceTypeFilter;
